<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">حالة جدول الحضور والانصراف</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table class="paginated-table table-striped table-hover mt-25">
            <md-table-row>
              <md-table-cell>ر.م</md-table-cell>
              <md-table-cell>اسم الموظف</md-table-cell>
              <md-table-cell>الفترة</md-table-cell>
            </md-table-row>
            <md-table-row v-for="(item, i) in data" :key="i">
              <md-table-cell>{{ i + 1 }}</md-table-cell>
              <md-table-cell>{{ item.employeeName }}</md-table-cell>
              <md-table-cell><span dir="ltr">{{ item.duration }}</span></md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"]
};
</script>
